export default __webpack_public_path__ + "static/media/Cookstand.3d5a8317.png";